import React, { useEffect, useState } from "react";
import styles from "./style.module.scss";
import Button from "components/atoms/Button/Button";
import InputField from "components/atoms/InputField/InputField";
import Loading from "components/atoms/Loading/Loading";
import {
  getSingleDataWithNameCompany,
  resetSearchData,
} from "store/slices/data.slice";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { toast } from "react-toastify";
import Tooltip from "components/atoms/Tooltip/Tooltip";
import Icon from "components/atoms/Icon/Icon";

const LeadFormNameCompany: React.FC = () => {
  const [name, setName] = useState<{ firstName: string; lastName: string }>({
    firstName: "",
    lastName: "",
  });
  const [companyEmailDomain, setcompanyEmailDomain] = useState<string>("");
  const { isLoading } = useAppSelector((state) => state.data.searchData);
  const dispatch = useAppDispatch();

  const save = (data: {
    firstName: string;
    lastName: string;
    companyEmailDomain: string;
  }) => {
    dispatch(getSingleDataWithNameCompany(data));
  };

  const handleSave = (e: any) => {
    e.preventDefault();
    const validName = /^[a-z,A-Z]+$/;
    const validateDomain =
      /^(https:\/\/)?(www\.)?([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
    if (!name.firstName) {
      return toast.error("Please fill First name");
    } else if (!name.lastName) {
      return toast.error("Please fill Last Name");
    } else if (!companyEmailDomain) {
      return toast.error("Please fill Company Domain");
    } else if (!validateDomain.test(companyEmailDomain)) {
      return toast.error("Please fill Valid Company Domain");
    } else if (
      !validName.test(name.firstName) ||
      !validName.test(name.lastName)
    ) {
      return toast.error("Please enter valid Name and Last Name");
    }
    save({ ...name, companyEmailDomain });
  };

  useEffect(() => {
    return () => {
      dispatch(resetSearchData());
    };
  }, []);

  return <form className={styles.form_oneinput}>
      <InputField
        type="text" size="small"
        value={name.firstName}
        onChange={(e: any) =>
          setName({ ...name, firstName: e.target.value })
        }
        placeholder="Enter Name"
      />
      <InputField
        type="text" size="small"
        value={name.lastName}
        onChange={(e: any) =>
          setName({ ...name, lastName: e.target.value })
        }
        placeholder="Enter Last Name"
      />
      <InputField
        type="text" size="small"
        value={companyEmailDomain}
        onChange={(e: any) => setcompanyEmailDomain(e.target.value)}
        placeholder="Enter Company Domain"
      />
      <div className="hidden sm:table-cell">
        <Tooltip content="Please make sure the Company Domain format follows the example: revenueinstitute.com">
          <div className="flex" style={{ cursor: 'help'}}>
            <Icon name="info" />
          </div>
      </Tooltip></div>
      {isLoading 
        ? <div className="flex items-center gap-3">
          <Loading height="38px" spinnerSize={25} />
          <p>Searching...</p>
        </div>
        : <Button
          className="w-full sm:w-max"
          iconName="search" size="sm"
          onClick={(e: any) => handleSave(e)}
        >Single Search</Button>
      }
  </form>
};

export default LeadFormNameCompany;
